import Vue from 'vue';

const config = {

  // From webpack DefinePlugin
  ENV: process.env.NODE_ENV,
  VERSION: VERSION,

  devMode: process.env.NODE_ENV=='development',

  shareUrl: "http://microsoft.com/",
  shareTitle: "Testing. Check it out...",

  overlayArtwork: '/static/images/ninjacat-emulator-010.8bit.logo2.png'
};

// Turn off Vue 'warning' even in dev mode
//Vue.config.silent = true;

export default config;



// WEBPACK FOOTER //
// ./src/data/config.js